<template>
  <div
    class="
      report--responses--price--wrap
      check-list-phone
      auto-list_col_centered
    "
  >
    <div>
      <div class="fs-14">
        <div v-if="type !== 'harvest'">
          {{ response.price_from_storage_driver | getPrice }}
          <span v-if="type === 'harvest_or_delivery'"> (П), </span>
        </div>
        <div v-if="type !== 'delivery'">
          {{ response.price_from_field_driver | getPrice }}
          <span v-if="type === 'harvest_or_delivery'"> (У) </span>
        </div>
      </div>
      <p class="cost-amount">
        <b>{{ getRound(response.costAmount, 1) }} руб</b>
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Price',
  props: {
    response: {
      type: Object,
      default: () => {},
    },
    type: {
      type: String,
      default: '',
    },
  },
}
</script>

<style lang="sass">
.report--responses--price--wrap
  p
    margin: 10px 0
    font-size: 14px
</style>
